import { render, staticRenderFns } from "./NoticeManagement.vue?vue&type=template&id=4697c9ed&scoped=true"
import script from "./NoticeManagement.vue?vue&type=script&lang=js"
export * from "./NoticeManagement.vue?vue&type=script&lang=js"
import style0 from "./NoticeManagement.vue?vue&type=style&index=0&id=4697c9ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4697c9ed",
  null
  
)

export default component.exports